import { ReactNode } from "react";
import Container from "@mui/material/Container";

export const PageContainer = ({ children }: { children?: ReactNode }) => (
  <Container maxWidth={false} sx={{ marginTop: 1 }}>
    {children}
  </Container>
);
